export const userTypes = {
    GET_PROFILE: "GET_PROFILE",
    AUTH_TOGGLE_POP_UP_STATUS: "AUTH_TOGGLE_POP_UP_STATUS",
    SET_USER_UNIQUE_ID: "SET_USER_UNIQUE_ID",
    SUCCEED_AUTH: "SUCCEED_AUTH",
    LOGOUT: "LOGOUT",
};